/*
 * Copyright (c) 2024-2026 Nodals AI Ltd
 * All rights reserved.
 */

import { BidRequestObject, PrebidFormattedKeyValues } from '../types/prebid';
import IndexExchange from './ix';

const ENABLED_BIDDERS = [IndexExchange];

const augmentBidRequest = (
  bidRequest: BidRequestObject,
  targetingData: PrebidFormattedKeyValues
): void => {
  const participantBidders: string[] = Array.from(
    new Set(bidRequest.adUnits.flatMap((unit) => unit.bids?.map((bid) => bid.bidder) || []))
  );

  ENABLED_BIDDERS.forEach((bidder) => {
    if (participantBidders.includes(bidder.bidderName)) {
      bidder.updateBidRequest(bidRequest, targetingData);
    }
  });
};

export default { augmentBidRequest };
